<template>

    <div v-cloak class="container-fluid" v-if="!isLoading">

        <div>
            <div class="row">
                <div class="col">
                    <h4 class="text-portal-soft-black pt-2">{{cmsContentBlocks['templateSelector.MainPage.Header']}}</h4>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <hr class="mt-0 mb-0 border-none taller-hr">
                </div>
            </div>

            <div class="row mt-3">
                <div class="col">
                    <h5 class="text-portal-soft-black" v-once>{{cmsContentBlocks['patientInHospital.Header']}}</h5>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <span class="text-portal-soft-red" v-once>{{cmsContentBlocks['allFieldsAreRequiredHeaderImportant']}}</span>
                    <span class="text-portal-soft-black" v-once>{{cmsContentBlocks['allFieldsAreRequiredHeader']}}</span>
                </div>
            </div>

            <div class="row mt-2 mt-lg-0">
                <div class="col">

                    <div class="row d-none d-lg-block">
                        <div class="col">
                            <hr>
                        </div>
                    </div>

                    <div class="row mt-2 mt-lg-0">
                        <div class="col-12 col-lg-6 pr-lg-0">

                            <div v-if="sendToThisMailbox" class="row text-portal-soft-black mb-2">
                                <div class="col" v-once>
                                    To: {{sendToThisMailbox}}
                                </div>
                            </div>

                            <div v-else>
                                <div>
                                    <div class="row text-portal-soft-black">
                                        <div class="col">
                                            {{cmsContentBlocks['generalOfficeCommunicationComponent.ToMailboxLabel']}}
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <div class="row mb-2">
                                        <div class="col">
                                            <select2-component key="drDropDown" title="Send message to this person" v-error-message="{ errorModel: 'errorModel.toMailboxId' }" class="form-control" :allowclear="false" :addblankentry="false" :options="physicianDropDown" v-model="messageModel.toMailboxId" :placeholder="cmsContentBlocks['appointmentRequestComponent.ToMailboxPlaceHolder']">
                                            </select2-component>
                                            <span class="invalid-feedback is-invalid">{{ errorModel.toMailboxId | firstError }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="showPhysicianDropDown">
                                <div class="row text-portal-soft-black mb-2">
                                    <div class="col">
                                        Physician
                                    </div>
                                </div>

                                <div class="row mb-2">
                                    <div class="col">
                                        <select2-component key="physDropDown" title="Send message to this person" v-error-message="{ errorModel: 'errorModel.toPhysicianId' }" class="form-control" :allowclear="false" :addblankentry="false" :options="reassignPhysicianDropDown" v-model="messageModel.toPhysicianId" :placeholder="cmsContentBlocks['appointmentRequestComponent.ToMailboxPlaceHolder']">
                                        </select2-component>
                                    </div>
                                </div>
                            </div>

                            <div class="row text-portal-soft-black mb-2">
                                <div class="col" v-once>
                                    <label for="subject">{{cmsContentBlocks['patientInHospital.SubjectLabel']}}</label>
                                </div>
                            </div>

                            <div class="row text-portal-soft-black mb-2">
                                <div class="col">
                                    <select2-component id="subject" key="subjectId" v-error-message="{ errorModel: 'errorModel.subjectId' }" class="form-control" :allowclear="false" :addblankentry="false" :options="subjectDropDown" v-model="messageModel.subjectId" :placeholder="cmsContentBlocks['patientInHospital.SubjectDropDownPlaceHolder']">
                                    </select2-component>
                                    <span class="invalid-feedback is-invalid">{{ errorModel.subjectId | firstError }}</span>
                                </div>
                            </div>
                            <div class="row text-portal-soft-black mb-2">
                                <div class="col" v-once>
                                    <label for="hospital-name">{{cmsContentBlocks['patientInHospital.HospitalNameLabel']}}</label>
                                </div>
                            </div>

                            <div class="row text-portal-soft-black mb-2">
                                <div class="col">
                                    <input id="hospital-name" type="text" :placeholder="cmsContentBlocks['patientInHospital.HospitalNameTextBoxPlaceHolder']" v-model="messageModel.hospitalName" v-error-message="{ errorModel: 'errorModel.hospitalName' }" class="form-control" maxlength="250" />
                                    <span class="invalid-feedback is-invalid">{{ errorModel.hospitalName | firstError }}</span>
                                </div>
                            </div>

                            <div class="row text-portal-soft-black">
                                <div class="col">
                                    <label for="hospital-date">{{cmsContentBlocks['patientInHospital.DateLabel']}}</label>
                                </div>
                            </div>

                            <div class="row mb-2">
                                <div class="col">
                                    <div class="input-group">
                                        <date-picker-component ref="preferredDesktop"
                                                               id="patient-in-hospital-date"
                                                               :typeable="true"
                                                               v-error-message="{ errorModel: 'errorModel.patientInHospitalDate' }"
                                                               class="form-control vdp-datepickerinput"
                                                               placeholder="MM / DD / YYYY"
                                                               format="MM/dd/yyyy"
                                                               v-model="messageModel.patientInHospitalDate">
                                        </date-picker-component>
                                        <div class="input-group-append">
                                            <div @click="$refs.preferredDesktop.showCalendar()" class="input-group-text bg-white rounded-right">
                                                <i class="far fa-calendar-alt text-primary"></i>
                                            </div>
                                        </div>
                                        <span class="invalid-feedback is-invalid">{{ errorModel.patientInHospitalDate | firstError }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-lg-6">
                            <div class="row">
                                <div class="col">
                                    <!--<banner-component v-if="nonEnglish" :bannerText="cmsContentBlocks.messageMustBeInEnglish"></banner-component>-->
                                    <message-body-component v-model="messageModel.messageBody"
                                                            :error-model="errorModel"
                                                            :cms-content-blocks="cmsContentBlocks"
                                                            :non-english="nonEnglish"></message-body-component>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col">
                                    <upload-component :attachment-group-id="attachmentGroupId">
                                        <template v-slot:multiple-error-slot>
                                            <span class="invalid-feedback is-invalid d-inline">{{ errorModel.attachmentGroupId | firstError }}</span>
                                        </template>
                                    </upload-component>
                                </div>
                            </div>

                        </div>


                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

    import moment from 'moment';
    import Datepicker from 'vuejs-datepicker';

    import formattingDirective from '@SharedVueComponents/formatting/formattingdirective';
    import errorMessageDirective from '@SharedVueComponents/Validation/ErrorMessageDirective';
    import composeMessageBody from '../../Common/message.body.vue';
    import select2Component from '@SharedVueComponents/select2/select2.vue';
    import uploadComponent from '@PortalVueComponents/Uploader/file.multiple.uploader.vue';
    import { mask } from 'vue-the-mask'
    import { ReferenceDataHttpSvc } from '@SharedHttpServices/reference.data.httpservice';
    import mskBanner from '@PortalVueComponents/Banner/msk.banner.vue'
    import { CmsHttpSvc } from '@SharedHttpServices/cms.httpservice';

    export default {
        name: 'patientInHospitalTemplate',
        props: {
            physicianDropDown: { type: Array },
            attachmentGroupId: { type: String },
            errorModel: { type: Object },
            cmsContentBlocks: { type: Object },
            //if set this is for ITC, DTC, etc. The "To Mailbox Id" will not be shown
            sendToThisMailbox: { type: String },
            //list of Reassign Physicians
            reassignPhysicianDropDown: { type: Array },
            //show or hide Reassign Physicians drop down
            showPhysicianDropDown: { type: Boolean },
            nonEnglish: { type: Boolean }
        },
        components: {
            'select2-component': select2Component,
            'message-body-component': composeMessageBody,
            'upload-component': uploadComponent,
            'date-picker-component': Datepicker,
            'banner-component': mskBanner
        },
        directives: {
            mask
        },
        data: function () {
            return {

                isLoading: true,

                subjectDropDown: [],//["I was admitted to a hospital or health facility other than MSK", "I will be admitted to a hospital or health facility other than MSK"],

                messageModel: {
                    toMailboxId: null, //mailbox id
                    toPhysicianId: "", //physician id
                    subjectId: null,
                    hospitalName: null,
                    patientInHospitalDate: null,
                    messageBody: '',
                    attachmentGroupId: this.attachmentGroupId,

                }
            }
        },
        mounted: function () {
            this.$emit('setMessageObject', this.messageModel);

            CmsHttpSvc.CmsSubjectContent('PatientInHospital')
                .done(response => {
                    this.subjectDropDown = response.map(x => x.subject);
                    this.isLoading = false;
                });
        },
        watch: {

            messageModel: {
                handler: function (newValue) {
                    this.$emit('setMessageObject', newValue);
                },
                deep: true
            },
        },
        methods: {}
    };
</script>

